import React, { Component } from "react";
import { connect } from 'react-redux';


//Material UI Imports
import AppBar from "@material-ui/core/AppBar";
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Fab from '@material-ui/core/Fab';
import SwipeableViews from 'react-swipeable-views';


//Actions
import { SetHeaderButtons } from '../../actions/headerButtonsActions';

//Views
import Item from "../../views/items/Item";
import Issue from "../../views/issues/Issue";
import Room from "../../views/rooms/Room";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLanguage } from "@fortawesome/free-solid-svg-icons";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}>
      {value === index && (
        <Box p={3}>
          <Grid>{children}</Grid>
        </Box>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};





class Locations extends Component {
    constructor(props) {
        super(props);
        this.state = 
            {  
              //Tabs
              tabValue: 0,
              //CharacterLimit
              characterLimit:30,
              
              openAddRoom:false,
              translationsRoom:false,

              openAddItem:false,
              translationsItem:false,

              openAddIssue:false,
              translationsIssue:false
            };

        //this.props.SetHeaderButtons(undefined);
    }

  componentDidMount(){
    document.title='Community - Locations'

  }
  //#region  HEADER BUTTONS
  SetHeaderButtons = (options) => {

    let headerButtons = undefined;

    if (options) {
      headerButtons = this.getHeaderButtons(options);
      //    console.log('loc but', headerButtons)
    }

    this.props.SetHeaderButtons(headerButtons)
  };

  getHeaderButtons = () => {
    return (
      <Grid>

      </Grid>
    )
  };
  //#endregion


  a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  };

    
    handleTabChange = (event, newValue) =>{
        this.handleChangeIndex(newValue);
    };

  //#region  HANDLERS
  handleronReturnClick = () => {

    if (this.props.onClose) {
      this.props.onClose();
    }
  };


    handleChangeIndex = (index) => {
      this.setState({
        tabValue:index,
        openAddIssue:false,
        openAddItem:false,
        openAddRoom:false
      
      })
      this.props.handlerOpenElementDetails(undefined);
    };
    //#endregion

    //#region  INNER COMPONENTS
    TabsComponent = () => {
      const   objStyles={
        tabsStyle : {
            backgroundColor:'#1f1f1f'
        },
        tabStyles :{
            backgroundColor:'#1f1f1f',
            borderTopLeftRadius:'16px',
            borderTopRightRadius:'16px',
            color:'white',
            fontFamily: 'Gotham-Bold',
            fontSize:'16px',
            textTransform: 'none',
        },
        SelectedTabStyle :{
            backgroundColor:'#454446',
            borderTopLeftRadius:'16px',
            borderTopRightRadius:'16px',
            color:'white',
            fontFamily: 'Gotham-Bold',
            fontSize:'16px',
            textTransform: 'none',  
        },
        swipeableViews:{
            width:'100%',
            backgroundColor:'#454446'
        }
      }    


      return(     
              <Grid container style={{width:'100%',margin:'0', padding:'0'}}>
              <AppBar position="static" style={{width:'100%', margin:'0', padding:'0', backgroundColor:'#2a2a2b'}} color="default" elevation={0} classes={{root:'Activity10'}}>
                  <Tabs
                      value={this.state.tabValue}
                      onChange={this.handleTabChange}
                      //indicatorColor="transparent"
                      TabIndicatorProps={{style:{backgroundColor:'transparent'}}}
                      variant="fullWidth"
                      aria-label="full width tabs community"
                      style={objStyles.tabsStyle}
                  >
                      <Tab label="Rooms" style={(this.state.tabValue ===0)?   objStyles.SelectedTabStyle: objStyles.tabStyles} {...this.a11yProps(0)} disableRipple = {true} disableFocusRipple={true}/>
                      <Tab label="Items" style={(this.state.tabValue ===1)?   objStyles.SelectedTabStyle: objStyles.tabStyles} {...this.a11yProps(1)} disableRipple = {true} disableFocusRipple={true} />
                      <Tab label="Issues" style={(this.state.tabValue ===2)?  objStyles.SelectedTabStyle: objStyles.tabStyles} {...this.a11yProps(2)} disableRipple = {true} disableFocusRipple={true}/>
                  </Tabs>
              </AppBar>
              <SwipeableViews
              axis={'x'}
              index={this.state.tabValue}
              onChangeIndex={this.handleChangeIndex}
              style={objStyles.swipeableViews}
              >
                  <TabPanel value={this.state.tabValue} index={0} dir={'x'}  >
                    <this.RoomsTab/>
                  </TabPanel>
                  <TabPanel value={this.state.tabValue} index={1} dir={'x'}>
                  <this.ItemsTab/>
                  </TabPanel>
                  <TabPanel value={this.state.tabValue} index={2} dir={'x'}>
                  <this.IssuesTab/>
                  </TabPanel>
              </SwipeableViews>
              {
                (this.state.openAddIssue && this.state.tabValue===2)&&
                <Fab 
                  color='primary' 
                  onClick={()=>this.setState({translationsIssue:true})} 
                  classes={{
                    root:'fab',
                    primary:"fabColor"
                  }}
                  size="large"
                  id='fab_issues'
                  >
                  <FontAwesomeIcon
                    icon={faLanguage}
                    color='white'
                    size='2x'
                  />
                </Fab>
              }

              {
                (this.state.openAddItem && this.state.tabValue===1)  &&
                <Fab 
                  color='primary' 
                  onClick={()=>this.setState({translationsItem:true})} 
                  classes={{
                    root:'fab',
                    primary:"fabColor"
                  }}
                  size="large"
                  id='fab_item'
                  >
                  <FontAwesomeIcon
                    icon={faLanguage}
                    color='white'
                    size='2x'
                  />
                </Fab>
              }
              {
                (this.state.openAddRoom && this.state.tabValue===0)&&
                <Fab 
                  color='primary' 
                  onClick={()=>this.setState({translationsRoom:true})} 
                  classes={{
                    root:'fab',
                    primary:"fabColor"
                  }}
                  size="large"
                  id='fab_rooms'
                  >
                  <FontAwesomeIcon
                    icon={faLanguage}
                    color='white'
                    size='2x'
                  />
                </Fab>
              }
             
          </Grid>
        )
    };

    RoomsTab = () =>{
      return (
        <Grid container style={{marginTop:'30px'}} justify='space-around'  >     
          <Room
            handlerOpenElementDetails= {() => this.props.handlerOpenElementDetails('room')}
            handlerCloseElementDetails={() => this.props.handlerCloseElementDetails('room')}
            characterLimit={this.state.characterLimit}
            openAddRoom={()=>this.setState({openAddRoom:true})}
            closeAddRoom={()=>this.setState({openAddRoom:false})}
            addTranslations={this.state.translationsRoom}
            closeTranslations={()=>this.setState({translationsRoom:false})}
          />
        </Grid>
      )
    };

    ItemsTab = () =>{
      return (
        <Grid container style={{marginTop:'30px'}} justify='space-around'  >     
          <Item
               handlerOpenElementDetails= {() => this.props.handlerOpenElementDetails('item')}
               handlerCloseElementDetails={() => this.props.handlerCloseElementDetails('item')}
              characterLimit={this.state.characterLimit}
              openAddItem={()=>this.setState({openAddItem:true})}
              closeAddItem={()=>this.setState({openAddItem:false})}
              addTranslations={this.state.translationsItem}
              closeTranslations={()=>this.setState({translationsItem:false})}
          />
        </Grid>
      )
    };

    IssuesTab = () =>{
      return (
        <Grid container style={{marginTop:'30px'}} justify='space-around'  >     
          <Issue
               handlerOpenElementDetails= {() => this.props.handlerOpenElementDetails('issue')}
               handlerCloseElementDetails={() => this.props.handlerCloseElementDetails('issue')}
               characterLimit={this.state.characterLimit}
               openAddIssue={()=>this.setState({openAddIssue:true})}
               closeAddIssue={()=>this.setState({openAddIssue:false})}
               addTranslations={this.state.translationsIssue}
              closeTranslations={()=>this.setState({translationsIssue:false})}

          />
        </Grid>
      )
    }
  //#endregion




  render() {
    return (
      <React.Fragment>
        <Grid container xs={12} style={{}}>
          <this.TabsComponent />
        </Grid>
      </React.Fragment>



    );
  }
}

function mapStateToProps(state, ownProps) {


  return {

  };
}

export default connect(mapStateToProps, { SetHeaderButtons })(Locations);